import {
    GET_SCREEN_DETAILS,
    GET_SCREEN_DETAILS_SUCCESS,
    GET_SCREEN_DETAILS_FAIL,
    UPDATE_SCREEN_DETAILS,
    UPDATE_SCREEN_DETAILS_SUCCESS,
    UPDATE_SCREEN_DETAILS_FAIL
  } from "./actionTypes"
  
  export const getScreenDetails = (jobId, candidateId) => ({
    type: GET_SCREEN_DETAILS,
    payload: {jobId, candidateId}
  })
  
  export const getScreenDetailsSuccess = screenDetails => ({
    type: GET_SCREEN_DETAILS_SUCCESS,
    payload: screenDetails,
  })
  
  export const getScreenDetailsFail = error => ({
    type: GET_SCREEN_DETAILS_FAIL,
    payload: error,
  })

  export const updateScreenDetails = (screenDetails) => ({
    type: UPDATE_SCREEN_DETAILS,
    payload: screenDetails,
  })
  
  export const updateScreenDetailsSuccess = success => ({
    type: UPDATE_SCREEN_DETAILS_SUCCESS,
    payload: success,
  })
  
  export const updateScreenDetailsFail = error => ({
    type: UPDATE_SCREEN_DETAILS_FAIL,
    payload: error,
  })